import { o as e, c as o, a as t } from "./core.0767a1be.js";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ t("path", { d: "m14 10 7-7M20 10h-6V4M3 21l7-7M4 14h6v6" }, null, -1), s = [
  r
];
function c(a, l) {
  return e(), o("svg", n, s);
}
const h = { render: c };
export {
  h as default,
  c as render
};
//# sourceMappingURL=collapse-expanded.920ad56a.js.map
